/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoWithdrawalRequest model module.
 * @module model/AccountControllerDtoWithdrawalRequest
 * @version 1.0
 */
class AccountControllerDtoWithdrawalRequest {
    /**
     * Constructs a new <code>AccountControllerDtoWithdrawalRequest</code>.
     * @alias module:model/AccountControllerDtoWithdrawalRequest
     */
    constructor() { 
        
        AccountControllerDtoWithdrawalRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoWithdrawalRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoWithdrawalRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoWithdrawalRequest} The populated <code>AccountControllerDtoWithdrawalRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoWithdrawalRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('managerNo')) {
                obj['managerNo'] = ApiClient.convertToType(data['managerNo'], 'Number');
            }
            if (data.hasOwnProperty('reason')) {
                obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoWithdrawalRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoWithdrawalRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reason'] && !(typeof data['reason'] === 'string' || data['reason'] instanceof String)) {
            throw new Error("Expected the field `reason` to be a primitive type in the JSON string but got " + data['reason']);
        }

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
AccountControllerDtoWithdrawalRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} managerNo
 */
AccountControllerDtoWithdrawalRequest.prototype['managerNo'] = undefined;

/**
 * @member {String} reason
 */
AccountControllerDtoWithdrawalRequest.prototype['reason'] = undefined;






export default AccountControllerDtoWithdrawalRequest;

